import { sync } from 'vuex-router-sync'
import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import Root from './Root'
import Vuex from 'vuex';
import vuexI18n from 'vuex-i18n';
import translationsEn from '../static/localization/translationsEn';
import vSelect from 'vue-select';
import VeeValidate from 'vee-validate';
import VueSweetAlert from 'vue-sweetalert';
import { Validator } from 'vee-validate';
import LexFilters from 'vue2-lex-filters';
import "froala-editor/js/plugins.pkgd.min.js";
import VueFroala from './vue-froala';
// register globally
import infiniteScroll from 'vue-infinite-scroll'
import moment from 'moment';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import { sentry_id } from "./config";
import Toasted from 'vue-toasted';
import Clipboard from 'v-clipboard'

const dictionary = {
  en: {
    messages:{
      alpha_spaces: () => 'Only alphabets and spaces are allowed.', 
    },

    attributes: {
      first_name: 'first name',
      last_name: 'last name',
      designation: 'Job title ',
      company :'organisation ',
      employ_count :'employee number',
      confirm_password :'re-type password',
      agree:'agree to the terms of service and privacy policy'
    }
  },
};

// Validator.updateDictionary(dictionary);

/**
* This is the Vuex store and it is
* avaible to all your components
*/
import store from './store'

/**
* This is the Router
*/
import router from './router'

/**
* $permission plugin
*/
import permissionPlugin from './plugins/permissions'


/**
* $http plugin based on axios
*/
import httpPlugin from './plugins/http'

/**
* eventbus plugin
*/
import eventbus from './plugins/eventbus'

/**
* jQuery and Bootstrap includes
*/
require('./includes')

try{
 Sentry.init({
   dsn: sentry_id,
   integrations: [new Integrations.Vue({Vue, attachProps: true})]
  // beforeSend: function(body){
  //   if (body.exception.mechanism.type == 'onunhandledrejection') {
  //     for (var i = 0; i < body.exception.values.length; i++) {
  //       if (body.exception.values[i].value == undefined) {
  //         var originalException = arguments[i + 1].originalException;
  //         if (originalException) {
  //           body.exception.values[i].type = originalException.constructor.name + ' [unhandled rejection]';
  //           body.exception.values[i].value = originalException.toString();
  //         }
  //       }
  //     }
  //   }
  //   return body;
  // }
  });
}
catch(e){
  // console.log("Some issue in sentry")
}
  // const dict = {
  //     en: {
  //         custom: {
  //             domainName: {
  //                 required: 'The domain name is required.' // messages can be strings as well.
  //             }
  //         }
  //     }
  // };

// VeeValidate.updateDictionary(dict);
/**
* Element UI
*/
Vue.use(ElementUI, { locale });
Vue.use(VeeValidate);

// Vue.$validator.updateDictionary(dict);

Vue.use(VueSweetAlert);
/**
* Make $http avaible to all components
* Send store and router to httpPlugin (injection)
*/
Vue.use(httpPlugin, { store, router })

Vue.use(permissionPlugin)

/* infinite scroll */
Vue.use(infiniteScroll);
/**
* Make $bus avaible to all components
*/
Vue.use(eventbus);

Vue.use(LexFilters);
Vue.use(Clipboard)

/*froala editor */
Vue.use(VueFroala);

// Effortlessly keep vue-router and vuex store in sync.
sync(store, router) // https://github.com/vuejs/vuex-router-sync/tree/next


// initialize the vuex store using the vuex module. note that you can change the
//  name of the module if you wish
const hf = new Vuex.Store({
	modules: {
		i18n: vuexI18n.store
	}
});

// Vue toast 

Vue.use(Toasted)

// initialize the internationalization plugin on the vue instance. note that
// the store must be passed to the plugin. the plugin will then generate some
// helper functions for components (i.e. this.$i18n.set, this.$t) and on the vue
// instance (i.e. Vue.i18n.set).
// Vue.use(vuexI18n.plugin, hf);

// // add translations directly to the application
// Vue.i18n.add('en', translationsEn);
// // Vue.i18n.add('de', translationsDe);

// // set the start locale to use
// Vue.i18n.set('en');

Vue.component('v-select', vSelect)

//Start filters
Vue.filter('formatDateTime', function(value) {
    if (value) {
      return moment(String(value)).format('DD MMM YYYY HH:mm:ss')
    }
});

Vue.filter('formatDate', function(value) {
    if (value) {
      return moment(String(value)).format('DD MMM YYYY')
    }
});

Vue.filter('removeUnderscoreWithSpace', function(value) {
  if (value) {
    return value.replace(/_/g, ' ')
  }
});

Vue.config.errorHandler = (err, vm, info) => {
};

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  if(nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }else{
    document.title = "Email Remediator";
  }
  next();
});

Vue.mixin({ // This mixin for clear all localstorage data
  methods: {
    removeItemFromLocalStorage: () => {
      localStorage.removeItem('emailRem-token');
      localStorage.removeItem('login');
      localStorage.clear();
      window.location.href = '/'
      // router.push({ name: 'auth.login' }).catch((e)=>{ 
      //   //
      // })
    },
    getCurrentYear(){
      return moment().format('YYYY')
    }
  }
})

export const bus = new Vue();
/* eslint-disable no-new */
new Vue({
  store, // injects the Store into all components
  router, // make Router work with the application
  el: '#app',
  render: h => h(Root),
})



// WEBPACK FOOTER //
// ./src/main.js